import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function Splitted({ width = 16, height = 16, fill = 'black' }: IconProps) {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66667 1.33334C7.03467 1.33334 7.33333 1.63201 7.33333 2.00001V4.66668C7.33333 5.03468 7.03467 5.33334 6.66667 5.33334H5.33333V6.66668H8.66667V6.00001C8.66667 5.63201 8.96533 5.33334 9.33333 5.33334H13.3333C13.7013 5.33334 14 5.63201 14 6.00001V8.66668C14 9.03468 13.7013 9.33334 13.3333 9.33334H9.33333C8.96533 9.33334 8.66667 9.03468 8.66667 8.66668V8.00001H5.33333V12H8.66667V11.3333C8.66667 10.9653 8.96533 10.6667 9.33333 10.6667H13.3333C13.7013 10.6667 14 10.9653 14 11.3333V14C14 14.368 13.7013 14.6667 13.3333 14.6667H9.33333C8.96533 14.6667 8.66667 14.368 8.66667 14V13.3333H4.66667C4.29867 13.3333 4 13.0347 4 12.6667V5.33334H2.66667C2.29867 5.33334 2 5.03468 2 4.66668V2.00001C2 1.63201 2.29867 1.33334 2.66667 1.33334H6.66667ZM12.6667 12H10V13.3333H12.6667V12ZM12.6667 6.66668H10V8.00001H12.6667V6.66668ZM6 2.66668H3.33333V4.00001H6V2.66668Z"
        fill={fill}
        fill-opacity="0.45"
      />
    </Svg>
  );
}
